// extracted by mini-css-extract-plugin
export var disabled = "_a-a";
export var hierarchyLinkGray = "_a-4";
export var hierarchyLinkUnderline = "_a-3";
export var hierarchyPrimary = "_a-0";
export var hierarchySecondary = "_a-1";
export var hierarchyTertiary = "_a-2";
export var pressed = "_a-6";
export var themeAction = "_a-5";
export var themeDestructive = "_a-8";
export var themeNormal = "_a-7";
export var themeSuccess = "_a-9";